const IQBATTRIES = 'iq-batteries'
const IQMICROINVERTERS = 'iq-microinverters'
const ENPHASEEVSES = 'enphase-evses'
const THIRDPARTYEVSES = 'third-party-evses'
const THIRDPARTYHPS = 'third-party-hps'

export {
  IQBATTRIES,
  IQMICROINVERTERS,
  ENPHASEEVSES,
  THIRDPARTYEVSES,
  THIRDPARTYHPS
}